{<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Filtros</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <label>Fecha desde</label>
            <br />
            <KitsDateTime v-model="model.desde" :currentValue="model.desde" />
          </div>
          <div class="col-md-6">
            <label>Fecha hasta</label>
            <br />
            <KitsDateTime v-model="model.hasta" :currentValue="model.hasta" />
          </div>
          <div class="col-md-6">
            <label>Tipo de movimiento</label>
            <br />
            <KitsCombo
              v-model="model.tipo"
              v-bind:items="tipos"
              propertyName="Description"
              propertyID="EntityID"
              :todos="true"
            ></KitsCombo>
          </div>

          <div class="col-md-6" v-if="esComercio">
            <label>Sucursales</label>
            <br />
            <KitsCombo
              v-model="sucursal"
              v-bind:items="sucursales"
              propertyName="Name"
              propertyID="EntityID"
              :todos="true"
            ></KitsCombo>
          </div>

          <div class="col-md-6">
            <label>Medio de Pago</label>
            <br />
            <KitsCombo
              v-model="model.medioDePago"
              v-bind:items="MediosDePago"
              propertyName="Description"
              propertyID="EntityID"
              :todos="true"
              :disabled="isPaymentMethodDisabled()"
            ></KitsCombo>
          </div>

          <div class="col-md-6" v-if="esComercio">
            <label>Cajas</label>
            <br />
            <KitsCombo
              v-model="model.caja"
              v-bind:items="cajas"
              propertyName="Name"
              propertyID="CashBoxID"
              :todos="true"
              :disabled="isAllSucursalSelected()"
            ></KitsCombo>
          </div>

          <div class="col-md-6" v-if="esComercio">
            <label>Cajeros</label>
            <br />
            <KitsCombo
              v-model="model.cajero"
              v-bind:items="cajeros"
              propertyName="Name"
              propertyID="CashierID"
              :todos="true"
              :disabled="isAllSucursalSelected()"
            ></KitsCombo>
          </div>
        </div>
        <div class="row" style="padding-top:20px">
          <div class="col-md-12 text-right">
             <b-button class="btn btn-success" @click="descargarMovements()">
              <i class="fa fa-fw fa-file-excel"></i>Descargar
            </b-button>
            <filter-button @click="filtrar" :disabled="!model.enableButtonDownloadMovements"></filter-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Movimientos</b-card-header>
      <b-card-body>
        <div v-if="movimientos.length ==0" class="text-center">
          <div>No se encontraron registros</div>
          <img src="/img/ic_no_resultado.png" style="width: 200px;" />
        </div>
        <div v-if="movimientos.length > 0">
          <!-- <b-button class="btn btn-success" @click="ExportMovements()">
            <i class="fa fa-fw fa-file-excel"></i>Exportar
          </b-button> -->
          <div
            class="row"
            v-for="item in movimientos"
            v-bind:key="item.ReceiptID"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
          >
            <div class="col-2" @click="itemClicked(item.ReceiptID)">
              <img :src="item.Image" class="circle-img" style="width: 50px" alt />
            </div>
            <div class="col-4" @click="itemClicked(item.ReceiptID)">
              {{item.Operation}}
              <br />
              {{item.DisplayName}}
            </div>
            <div
              class="col-4 text-right"
              style="padding-top: 10px;"
              @click="itemClicked(item.ReceiptID)"
            >
              {{item.FormatedAmount}}
              <br />
              {{item.FormatedDate.substring(0,10)}}
              <br />
              {{item.FormatedDate.substring(11,19)}}
            </div>
            <div class="col-1">
              <button
                class="btn btn-danger btn-sm"
                @click="btnDevolverCobroClick(item)"
                v-if="item.ReturnPaymentEnabled"
              >
                <i class="fa fa-fw fa-undo"></i> Devolver Cobro
              </button>
            </div>
            <div class="col-1">
              <button
                class="btn btn-outline-danger btn-sm"
                @click="btnVerDevolucionesClick(item)"
                v-if="item.GetQRDebinChargeBackListEnabled"
              >
                <i class="fa fa-fw fa-file"></i> Ver Devoluciones
              </button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <modal :show.sync="modal.show" style="z-index: 9999;">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">{{movimiento.Operation}}</h5>
      </template>
      <div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">
            <img :src="movimiento.Image" class="circle-img" style="width: 60px" alt />
          </div>
        </div>
        <div class="row" style="margin-bottom:20px" v-show="movimiento.ArticleName != null">
          <div class="col-md-12 text-center">{{movimiento.ArticleName}}</div>
        </div>
        <div class="row" style="margin-bottom:20px" v-show="movimiento.Reference != null">
          <div class="col-md-12 text-center">{{movimiento.DisplayName}}</div>
        </div>
        <div
          class="row"
          v-if="movimiento.Aux1Description != '' && movimiento.Aux1Description != null"
        >
          <div class="col-md-12">
            <strong>{{movimiento.Aux1Description}}:</strong>
            {{movimiento.Aux1Value}}
          </div>
        </div>
        <div
          class="row"
          v-if="movimiento.Aux2Description != '' && movimiento.Aux2Description != null"
        >
          <div class="col-md-12">
            <strong>{{movimiento.Aux2Description}}:</strong>
            {{movimiento.Aux2Value}}
          </div>
        </div>

        <div
          class="row"
          v-if="movimiento.Aux3Description != '' && movimiento.Aux3Description != null"
        >
          <div class="col-md-12">
            <strong>{{movimiento.Aux3Description}}:</strong>
            {{movimiento.Aux3Value}}
          </div>
        </div>

        <div
          class="row"
          v-if="movimiento.Aux4Description != '' && movimiento.Aux4Description != null"
        >
          <div class="col-md-12">
            <strong>{{movimiento.Aux4Description}}:</strong>
            {{movimiento.Aux4Value}}
          </div>
        </div>

        <div class="row" v-show="movimiento.Reference != null">
          <div class="col-md-12">
            <strong>{{labelReferencia}}:</strong>
            {{movimiento.Reference}}
          </div>
        </div>

        <div class="row" v-show="movimiento.ExternalReference != null">
          <div class="col-md-12">
            <strong>Referencia Externa:</strong>
            {{movimiento.ExternalReference}}
          </div>
        </div>

        <div class="row" v-show="movimiento.TransactionNumber != null">
          <div class="col-md-12">
            <strong>Número transacción:</strong>
            {{movimiento.TransaccionNumber}}
          </div>
        </div>

        <div class="row" v-show="movimiento.DebinName != null && movimiento.DebinName != ''">
          <div class="col-md-12">
            <strong>Nombre:</strong>
            {{movimiento.DebinName}}
          </div>
        </div>

        <div class="row" v-show="movimiento.DebinCUIT != null && movimiento.DebinCUIT != ''">
          <div class="col-md-12">
            <strong>CUIT/CUIL:</strong>
            {{movimiento.DebinCUIT}}
          </div>
        </div>

        <div class="row" v-show="movimiento.DebinCBU != null && movimiento.DebinCBU != ''">
          <div class="col-md-12">
            <strong>CBU/CVU:</strong>
            {{movimiento.DebinCBU}}
          </div>
        </div>

        <div
          class="row"
          v-show="movimiento.TransactionPlatformID != null && movimiento.TransactionPlatformID != ''"
        >
          <div class="col-md-12">
            <strong>{{labelNroOperacionOriginal}}</strong>
            {{movimiento.TransactionPlatformID}}
          </div>
        </div>

        <div
          class="row"
          v-show="movimiento.PaymentMethodName != null && movimiento.PaymentMethodName != ''"
        >
          <div class="col-md-12">
            <strong>Medio de pago:</strong>
            {{movimiento.PaymentMethodName}}
          </div>
        </div>

        <div class="row" v-show="movimiento.Dues != null && movimiento.Dues != 0">
          <div class="col-md-12">
            <strong>Cuotas:</strong>
            {{movimiento.Dues}}
          </div>
        </div>

        <div class="row" v-show="movimiento.BrandCard != null && movimiento.BrandCard != ''">
          <div class="col-md-12">
            <strong>Marca tarjeta:</strong>
            {{movimiento.BrandCard}}
          </div>
        </div>

        <div class="row" v-show="movimiento.DNIPayer != null && movimiento.DNIPayer != ''">
          <div class="col-md-12">
            <strong>Nro de serie:</strong>
            {{movimiento.DNIPayer}}
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <strong>Fecha:</strong>
            {{movimiento.FormatedDate}}
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <strong>Importe:</strong>
            {{movimiento.FormatedAmount}}
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <strong>Comprobante:</strong>
            {{movimiento.FormatedReceipt}}
          </div>
        </div>

         <div class="row" v-if="movimiento.ChargeUser && movimiento.Cashier">
          <div class="col-md-12">
            <strong>Usuario devolución:</strong>
            {{movimiento.Cashier}}
          </div>
        </div>

        <div
          class="row"
          v-show="movimiento.InternalIDDebin != null && movimiento.InternalIDDebin != ''"
        >
          <div class="col-md-12">
            <strong>ID DEBIN:</strong>
            {{movimiento.InternalIDDebin}}
          </div>
        </div>

        <div
          class="row"
          style="padding-top: 5px; padding-bottom:5px; margin-left:2px"
          v-show="movimiento.TitleInitialReceipt != null && movimiento.TitleInitialReceipt != ''"
        >
          <div class="col-md-9" style="border-top: 1px solid #D6D6D6;"></div>
        </div>

        <div
          class="row"
          v-show="movimiento.TitleInitialReceipt != null && movimiento.TitleInitialReceipt != '' && movimiento.TitleInitialReceipt.includes('Cobro')"
        >
          <div class="col-md-12 text-success">{{movimiento.TitleInitialReceipt}}</div>
        </div>

        <div
          class="row"
          v-show="movimiento.TitleInitialReceipt != null && movimiento.TitleInitialReceipt != '' && movimiento.TitleInitialReceipt.includes('Pago')"
        >
          <div class="col-md-12 text-danger">{{movimiento.TitleInitialReceipt}}</div>
        </div>

        <div
          class="row"
          v-show="movimiento.FormatedDateReceiptInital != null && movimiento.FormatedDateReceiptInital != ''"
        >
          <div class="col-md-12">
            <strong>Fecha:</strong>
            {{movimiento.FormatedDateReceiptInital}}
          </div>
        </div>

        <div
          class="row"
          v-show="movimiento.FormatedAmountReceiptInital != null && movimiento.FormatedAmountReceiptInital != ''"
        >
          <div class="col-md-12">
            <strong>Importe:</strong>
            {{movimiento.FormatedAmountReceiptInital}}
          </div>
        </div>

        <div
          class="row"
          v-show="movimiento.IDQRDebinReceiptInitial != null && movimiento.IDQRDebinReceiptInitial != ''"
        >
          <div class="col-md-12">
            <strong>ID DEBIN:</strong>
            {{movimiento.IDQRDebinReceiptInitial}}
          </div>
        </div>

        <div class="row mt-4" v-show="movimiento.TicketDescargable">
          <div class="col-md-12 text-center">
            <button
              @click="descargarComprobante(movimiento.ReceiptID)"
              class="btn btn-success btn-sm"
            >Descargar comprobante</button>
          </div>
        </div>

        <div class="row" v-if="movimiento.CashBoxID != null">
          <div v-if="movimiento.ChargeUser" class="col-md-12">
            <b>Sucursal:</b>
            {{movimiento.BranchBox}} -
            <b>Caja:</b>
            {{movimiento.CashBox}} -
            <b>Cajero:</b>
            {{movimiento.ChargeUser}}
          </div>
          <div v-else>
            <b>Sucursal:</b>
            {{movimiento.BranchBox}} -
            <b>Caja:</b>
            {{movimiento.CashBox}} -
            <b>Cajero:</b>
            {{movimiento.Cashier}}
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modal.show = false">Cerrar</base-button>
      </template>
    </modal>

    <modal :show.sync="showModalDevolverCobro" :show-close="false">
      <template slot="header">
        <h5 class="modal-title" style="color:red">Devolver Cobro QR Externo</h5>
      </template>
      <div v-if="MostrarMensajeDevolucion == false">
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">
            <img :src="ImagenModal" class="circle-img" style="width: 60px" alt />
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">Devolver a otra Billetera</div>
        </div>
        <div class="row" style="margin-bottom: 10px" v-show="devolverCobroQR.TotalAmount != null">
          <div class="col-md-12 text-center">Total importe {{devolverCobroQR.TotalAmount}}</div>
        </div>
        <br />
        <div class="row" style="margin-bottom: 10px">
          <div class="col-7 text-left" style="margin: 0 auto;">Importe a devolver</div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-7" style="margin: 0 auto;">
            <input
              type="text"
              class="form-control form-control-sm"
              :disabled="!$store.getters.HabilitarDevolucionParcialQR"
              v-model="inputAmount"
            />
          </div>
        </div>
        <div
          class="row"
          style="margin-bottom: 10px"
          v-show="devolverCobroQR.AvaliableAmount != null"
        >
          <div
            class="col-md-12 text-center"
          >A devolver $ {{devolverCobroQR.ReturnAmount}} / Disponible $ {{devolverCobroQR.AvaliableAmount}}</div>
        </div>
        <br />
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">
            <button class="btn btn-danger" type="button" @click="devolverCobro()">
              <i class="fa fa-plus fa-undo"></i>
              Devolver Cobro
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="col-md-12">
          <base-alert :type="resultadoDevolucion.Tipo">
            <span class="alert-inner--icon">
              <i :class="resultadoDevolucion.Icono"></i>
            </span>
            <span class="alert-inner--text" v-text="resultadoDevolucion.Texto"></span>
          </base-alert>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="cerrarModalDevolverCobro()">Cerrar</base-button>
      </template>
    </modal>

    <modal :show.sync="showModalVerDevoluciones">
      <template slot="header">
        <h5 class="modal-title" style="color:red">Devoluciones Cobro QR Externo</h5>
      </template>
      <div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">
            <img :src="ImagenModal" class="circle-img" style="width: 60px" alt />
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12 text-center">Devoluciones Otras Billeteras</div>
        </div>
        <div
          class="row"
          v-for="item in devolucionesQRExterno"
          v-bind:key="item.ReceiptID"
          style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
        >
          <div class="col-2" @click="itemClicked(item.ReceiptID)">
            <img :src="item.Image" class="circle-img" style="width: 50px" alt />
          </div>
          <div class="col-4" @click="itemClicked(item.ReceiptID)">
            {{item.Operation}}
            <br />
            {{item.ArticleName}}
          </div>
          <div
            class="col-4 text-right"
            style="padding-top: 10px;"
            @click="itemClicked(item.ReceiptID)"
          >
            {{item.FormatedAmount}}
            <br />
            {{item.FormatedReceiptDate}}
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="showModalVerDevoluciones = false">Cerrar</base-button>
      </template>
    </modal>
  </div>
</template>

<style>
.btn-success {
  cursor: pointer;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import fileHelpers from "@/helpers/fileHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";
import store from "@/store";
import KitsCombo from "@/components/KitsCombo";
import KitsDateTime from "@/components/KitsDateTime";
import KitsDate from "@/components/KitsDate";

import DateTime from "luxon/src/datetime.js";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: { KitsCombo, KitsDateTime, KitsDate },
  data() {
    return {
      movimientos: [],
      movimiento: {
        Image: "",
        DisplayName: "",
        FormatedAmount: "",
        Operation: "",
        Aux1Description: "",
        Aux1Value: "",
        Aux2Description: "",
        Aux2Value: "",
        Aux3Description: "",
        Aux3Value: "",
        Aux4Description: "",
        Aux4Value: "",
        ReferenceVisible: "",
        Reference: "",
        ExternalReference: "",
        FormatedReceipt: "",
        FormatedDate: "",
        TransactionNumberVisible: "",
        TransaccionNumber: "",
        CashBox: "",
        BranchBox: "",
        Cashier: "",
        CashBoxID: null,
        ReceiptID: "",
        DebinQRId: "",
        TicketDescargable: false,
        ReturnPaymentEnabled: false,
        GetQRDebinChargeBackListEnabled: false,
        ChargeUser: ""
      },
      modal: {
        show: false
      },
      tipos: [],
      MediosDePago: [],

      labelReferencia: "Referencia",
      labelNroOperacionOriginal: "",

      sucursales: [],
      cajas: [],
      cajeros: [],

      devolverCobroQR: {
        ReceiptID: "",
        TotalAmount: "",
        AvaliableAmount: 0,
        ReturnAmount: 0
      },

      ImagenModal: "",

      MostrarMensajeDevolucion: false,

      resultadoDevolucion: {
        Texto: "",
        Tipo: "",
        Icono: "",
        Exito: false
      },

      devolucionesQRExterno: [],
      devolucionQRExterno: {
        Image: "",
        ArticleName: "",
        FormatedAmount: "",
        Operation: "",
        FormatedReceiptDate: "",
        ReceiptID: ""
      },

      esComercio: false,
      sucursal: null,

      showModalDevolverCobro: false,

      showModalVerDevoluciones: false,

      inputAmount: "",

      dateFromDownload: "",
      dateToDownload: "",

      model: {
        desde: "",
        hasta: "",
        tipo: null,
        medioDePago: null,
        caja: null,
        cajero: null,
        enableButtonDownloadMovements: true,
      }
    };
  },
  methods: {
    sucursalChanged() {
      let context = this;

      context.model.cajas = [];
      context.model.cajeros = [];

      if (this.sucursal != null && !isNaN(this.sucursal)) {
        axiosHelpers.axiosGet(
          "Commerce/GetCashBoxByBranchOffice",
          { BranchOfficeID: this.sucursal },
          this,
          function(data) {
            context.cajas = data.ResponseVM.Items;
          }
        );

        this.getCashiersByBranchOffice();
      } else {
        context.model.caja = null;
        context.model.cajero = null;
      }
    },
    ValidateDownloadMovements(){
      let context = this;
      if(datetimeHelpers.compareDifference(context.model.desde, context.model.hasta, 3) && context.model.tipo == null)
      {
        context.model.enableButtonDownloadMovements = false;
        return;
      }

      if(datetimeHelpers.compareDifference(context.model.desde, context.model.hasta, 7) && context.model.tipo != null)
      {
        context.model.enableButtonDownloadMovements = false;
        return;
      }

      context.model.enableButtonDownloadMovements = true;
    },
    descargarMovements(){
      if (datetimeHelpers.compareFromTo(this.model.desde, this.model.hasta)) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La fecha hasta debe ser superior a la fecha desde",
          this
        );
        return;
      }

      let req = {
        dateFrom: this.model.desde,
        dateTo: this.model.hasta,
        receiptTypeID: this.model.tipo,
        BranchOfficeID: this.sucursal,
        PaymentMethodID: this.model.medioDePago,
        CashBoxID: this.model.caja,
        CashierID: this.model.cajero
      };

      let context = this;

      axiosHelpers.axiosGet("Operation/GetAccountMovesDetalladoToDownload", req, this, function(
        response
      ) {
        if(response.ResponseVM.HasErrors == false){
           var contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileHelpers.downloadFile(
            context,
            response.ResponseVM.FileContent,
            response.ResponseVM.FileName,
            contentType
          );
        }
      });
    },
    filtrar() {
      if (datetimeHelpers.compareFromTo(this.model.desde, this.model.hasta)) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La fecha hasta debe ser superior a la fecha desde",
          this
        );
        return;
      }

      if (
        datetimeHelpers.compareDifference(
          this.model.desde,
          this.model.hasta,
          62
        )
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El rango de fechas ingresado no puede superar los 2 meses",
          this
        );
        return;
      }

      let req = {
        dateFrom: this.model.desde,
        dateTo: this.model.hasta,
        receiptTypeID: this.model.tipo,
        BranchOfficeID: this.sucursal,
        PaymentMethodID: this.model.medioDePago,
        CashBoxID: this.model.caja,
        CashierID: this.model.cajero
      };

      let context = this;

      this.dateFromDownload = this.model.desde;
      this.dateToDownload = this.model.hasta;

      axiosHelpers.axiosGet("Operation/GetAccountMovesDetallado", req, this, function(
        data
      ) {
        for (let i = 0; i < data.ResponseVM.Items.length; i++) {
          data.ResponseVM.Items[i].Image = generalHelpers.getLocalImage(
            data.ResponseVM.Items[i].Image
          );
        }

        context.movimientos = data.ResponseVM.Items;
      });
    },
    ExportMovements() {
      let context = this;

      var items = [];
      context.movimientos.forEach(x => {
        var movement = {
          Operation: x.Operation,
          DisplayName: x.DisplayName,
          FormatedDate: x.FormatedDate,
          Amount: x.Amount,
          ReceiptReference: x.ReceiptReference,
          IDComprobante: x.ReceiptID,
          CashBox: x.CashBox,
          BranchBox: x.BranchBox,
          Cashier: x.Cashier
        };
        items.push(movement);
      });
      axiosHelpers.axiosPost(
        "Operation/GetAccountMovesDetalladoExport",
        { DateFrom: context.dateFromDownload, DateTo: context.dateToDownload, Items: items },
        this,
        function(response) {
          var contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileHelpers.downloadFile(
            context,
            response.ResponseVM.FileContent,
            response.ResponseVM.FileName,
            contentType
          );
        }
      );
    },
    itemClicked(ReceiptID) {
      let context = this;
      axiosHelpers.axiosGet(
        "Operation/GetReceiptDetailsDetallado",
        { ReceiptID: ReceiptID },
        this,
        function(data) {
          context.movimiento = data.ResponseVM;
          context.movimiento.Image = generalHelpers.getLocalImage(
            context.movimiento.Image
          );
          if (
            data.ResponseVM.ReceiptTypeID ==
            store.getters.PagoProveedorTypeReceiptID
          ) {
            context.labelReferencia = "Observación";
          }

          if (
            data.ResponseVM.ReceiptTypeID ==
            store.getters.FintouchReceipTypeEntryOperationId
          ) {
            context.labelNroOperacionOriginal = "Nro. de Operación:";
          } else {
            context.labelNroOperacionOriginal = "Nro. de Operación original:";
          }

          context.modal.show = true;
        }
      );
    },
    descargarComprobante(receiptID) {
      let context = this;

      axiosHelpers.axiosGet(
        "Operation/ObtenerReporteComprobanteOperacion",
        { ComprobanteID: receiptID },
        this,
        function(data) {
          var bytesBase64 = data.ResponseVM.ContenidoArchivoReporte;

          var fileName = data.ResponseVM.NombreArchivoReporte;
          var contentType = "application/pdf";

          fileHelpers.downloadFile(context, bytesBase64, fileName, contentType);
        }
      );
    },
    getDevolverCobro(item) {
      let context = this;

      context.devolverCobroQR.ReceiptID = item.ReceiptID;
      context.ImagenModal = item.Image;

      axiosHelpers.axiosGet(
        "Operation/GetAvailableAmount",
        { QRDebinID: item.DebinQRId },
        this,
        function(data) {
          context.devolverCobroQR.TotalAmount = item.FormatedAmount;
          context.devolverCobroQR.ReturnAmount =
            data.ResponseVM.AvailableAmount;
          context.devolverCobroQR.AvaliableAmount =
            data.ResponseVM.AccountCredit;

          if (store.getters.HabilitarDevolucionParcialQR) {
            context.inputAmount = "";
          } else {
            context.inputAmount = data.ResponseVM.AvailableAmount;
          }
        }
      );
    },
    cerrarModalDevolverCobro() {
      let context = this;
      context.showModalDevolverCobro = false;
      context.MostrarMensajeDevolucion = false;
      if (context.resultadoDevolucion.Exito) {
        this.filtrar();
      }
    },
    openModalDevolverCobro() {
      let context = this;
      context.inputAmount = "";
      context.MostrarMensajeDevolucion = false;
      context.showModalDevolverCobro = true;
    },
    btnDevolverCobroClick(item) {
      this.getDevolverCobro(item);
      this.openModalDevolverCobro();
    },
    getDevoluciones(item) {
      let context = this;

      context.ImagenModal = item.Image;

      axiosHelpers.axiosGet(
        "Operation/GetListOfReturns",
        { QRDebinID: item.DebinQRId },
        this,
        function(data) {
          context.devolucionesQRExterno = data.ResponseVM.ListQRChargeBack;
        }
      );
    },
    openModalVerDevoluciones() {
      let context = this;
      context.showModalVerDevoluciones = true;
    },
    btnVerDevolucionesClick(item) {
      this.getDevoluciones(item);
      this.openModalVerDevoluciones();
    },
    devolverCobro() {
      let context = this;

      if (isNaN(context.inputAmount) || parseFloat(context.inputAmount) == 0) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe ingresar un importe.",
          this
        );
        return;
      }

      if (context.inputAmount > context.devolverCobroQR.ReturnAmount) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El importe ingresado es mayor que el importe a devolver.",
          this
        );
        return;
      }

      axiosHelpers.axiosPostWithoutAlerts(
        "Operation/DevolverCobroQR",
        {
          ReceiptID: context.devolverCobroQR.ReceiptID,
          Amount: context.inputAmount
        },
        context,
        function(data) {
          context.MostrarMensajeDevolucion = true;

          if (data.ResponseVM.ResultOk) {
            context.resultadoDevolucion = {
              Texto: "Devolución exitosa!",
              Tipo: "success",
              Icono: "fa fa-fw fa-thumbs-up",
              Exito: true
            };
          } else if (data.Alerts.length > 0) {
            context.resultadoDevolucion = {
              Texto: data.Alerts[0].Message,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down",
              Exito: false
            };
          }
        }
      );
    },
    isAllSucursalSelected() {
      let context = this;

      if (context.sucursal == null || isNaN(context.sucursal)) {
        return true;
      } else {
        return false;
      }
    },
    getCashiersByBranchOffice() {
      let context = this;

      axiosHelpers.axiosGet(
        "Commerce/GetCashiersByBranchOffice",
        { BranchOfficeID: this.sucursal },
        this,
        function(data) {
          context.cajeros = data.ResponseVM.Items;
        }
      );
    },
    isPaymentMethodDisabled() {
      let context = this;

      var FintouchReceipTypeEntryOperationId =
        store.getters.FintouchReceipTypeEntryOperationId;
      if (
        context.model.tipo == store.getters.FintouchReceipTypeEntryOperationId
      ) {
        return false;
      } else {
        context.model.medioDePago = null;
        return true;
      }
    },
  },
  beforeMount: function() {
    let context = this;

    console.log("model: " + context);
    context.esComercio = store.getters.isCommerce;
    if (context.esComercio || store.getters.isCashier) {
      axiosHelpers.axiosGet(
        "ReceiptType/GetCommerceReceiptTypes",
        {},
        this,
        function(data) {
          context.tipos = data.ResponseVM;
        }
      );
    } else {
      axiosHelpers.axiosGet(
        "ReceiptType/GetClientReceiptTypes",
        {},
        this,
        function(data) {
          context.tipos = data.ResponseVM;
        }
      );
    }

    axiosHelpers.axiosPost("Commerce/GetBranchOffices", {}, this, function(
      data
    ) {
      context.sucursales = data.ResponseVM.Items;
    });

    axiosHelpers.axiosGet(
        "OperationsFintouch/GetPaymentMethods",
        {},
        this,
        function(data) {
          context.MediosDePago = data.ResponseVM;
        }
    );
  },
  mounted: function() {
    //this.model.desde = datetimeHelpers.getMonthStart();
    this.model.desde = datetimeHelpers.getToday();
    this.model.hasta = datetimeHelpers.getNextDay();
  },
  watch: {
    sucursal: function(newValue, oldValue) {
      this.sucursalChanged();
    },
    "model.desde" : function(newValue, oldValue) {
      this.ValidateDownloadMovements();
    },
    "model.hasta" : function(newValue, oldValue) {
      this.ValidateDownloadMovements();
    },
    "model.tipo" : function(newValue, oldValue) {
      this.ValidateDownloadMovements();
    },
  }
};
</script>}